<!-- Dependent Banner -->
@if (dependentService.isActingAsDependent()) {
  <div class="dependent-banner">
    <mat-icon class="banner-icon">person</mat-icon>
    <span class="banner-text">{{ 'Managing' | translate }}: <strong>{{ dependentService.activeProfile()?.fullname }}</strong></span>
    <button class="banner-close" (click)="switchToSelf()">
      <mat-icon>close</mat-icon>
      <span>{{ 'Back to my profile' | translate }}</span>
    </button>
  </div>
}

<!-- Actively payment warning: club admins only -->
@if (isUserAdmin && billingNotice.notice() && !billingNotice.dismissed()) {
  <div class="billing-banner" [class.billing-banner--overdue]="billingNotice.notice()?.overdue" role="status">
    <mat-icon class="banner-icon">payments</mat-icon>
    <span class="banner-text">
      <strong>{{ 'Outstanding Actively bill' | translate }}: {{ billingNotice.amount() }}</strong>
      @if (billingNotice.dueDate()) { · {{ 'Due by' | translate }} {{ billingNotice.dueDate() }} }
      @if (billingNotice.notice()?.message) { · {{ billingNotice.notice()?.message }} }
      @if (billingNotice.notice()?.iban) { · IBAN {{ billingNotice.notice()?.iban }} }
      @if (billingNotice.notice()?.contact_email) { · <a [href]="'mailto:' + billingNotice.notice()?.contact_email">{{ billingNotice.notice()?.contact_email }}</a> }
      <span class="banner-only">{{ 'Only club admins see this message. Members do not.' | translate }}</span>
    </span>
    <button class="banner-close" type="button" (click)="billingNotice.dismiss()" [attr.aria-label]="'Close' | translate">
      <mat-icon>close</mat-icon>
    </button>
  </div>
}

<div class="header-content">
  @if (logo_URL && logo_URL.length > 2) {
    <img [src]="logo_URL" class="logo" alt="logo" />
  } @else {
    <div class="logo-placeholder">
      <mat-progress-spinner
        diameter="24"
        mode="indeterminate"
      ></mat-progress-spinner>
    </div>
  }

  <button class="header-btn menu-btn" (click)="toggleDrawer()">
    <mat-icon>menu</mat-icon>
  </button>

  <div class="spacer"></div>

  @if (isUserLoggedIn | async) {
    <div class="right-actions">
      <button class="header-btn" [matMenuTriggerFor]="userMenu" [class.acting-as-dependent]="dependentService.isActingAsDependent()">
        <mat-icon>person_outline</mat-icon>
      </button>

      <button
        class="header-btn notif-btn"
        [matBadge]="notifCount"
        [matBadgeHidden]="notifCount == 0"
        matBadgeColor="warn"
        matBadgeSize="small"
        (click)="toggleNotifications()"
      >
        <mat-icon>notifications_none</mat-icon>
      </button>
    </div>

    <mat-menu #userMenu>
      @if (isLoggedIn | async; as user) {
        <!-- Profile Switcher -->
        @if (familyEnabled && dependentService.dependents().length > 0) {
          <div class="profile-switcher-label">
            <mat-icon>swap_horiz</mat-icon>
            <span>{{ 'Switch Profile' | translate }}</span>
          </div>

          <!-- Parent (self) -->
          <button mat-menu-item (click)="switchToSelf()" class="profile-item" [class.active-profile]="!dependentService.isActingAsDependent()">
            <mat-icon>{{ dependentService.isActingAsDependent() ? 'radio_button_unchecked' : 'check_circle' }}</mat-icon>
            <span>{{ email }} <span class="you-label">({{ 'You' | translate }})</span></span>
          </button>

          <!-- Dependents -->
          @for (dep of dependentService.dependents(); track dep.dependent_user_id) {
            @if (dep.is_approved) {
              <button mat-menu-item (click)="switchProfile(dep.dependent_user_id)" class="profile-item" [class.active-profile]="dependentService.activeProfile()?.dependent_user_id === dep.dependent_user_id">
                <mat-icon>{{ dependentService.activeProfile()?.dependent_user_id === dep.dependent_user_id ? 'check_circle' : 'radio_button_unchecked' }}</mat-icon>
                <span>{{ dep.fullname }} @if (dep.relationship) { <span class="relationship-label">({{ dep.relationship | translate }})</span> }</span>
              </button>
            } @else {
              <button mat-menu-item disabled class="profile-item profile-item-pending">
                <mat-icon>hourglass_empty</mat-icon>
                <span>{{ dep.fullname }} <span class="pending-label">({{ 'Pending Approval' | translate }})</span></span>
              </button>
            }
          }

          <mat-divider></mat-divider>
        }

        <button mat-menu-item (click)="profileSettings()">
          <mat-icon>person_outline</mat-icon>
          <span>{{ 'Profile Settings' | translate }}</span>
        </button>
        <button mat-menu-item (click)="logout()">
          <mat-icon>logout</mat-icon>
          <span>{{ 'Logout' | translate }}</span>
        </button>
      } @else {
        <button mat-menu-item (click)="openDialog()">
          <mat-icon>login</mat-icon>
          <span>{{ 'Login' | translate }}</span>
        </button>
        <button mat-menu-item (click)="openRegisterDialog()">
          <mat-icon>start</mat-icon>
          <span>{{ 'Register' | translate }}</span>
        </button>
      }
    </mat-menu>
  } @else {
    <div class="right-actions">
      <button class="header-btn text-btn" (click)="openDialog()">
        <mat-icon>login</mat-icon>
        <span>{{ 'Login' | translate }}</span>
      </button>
      <button class="header-btn text-btn" (click)="openRegisterDialog()">
        <mat-icon>start</mat-icon>
        <span>{{ 'Register' | translate }}</span>
      </button>
    </div>
  }
</div>
